import mixpanel from 'mixpanel-browser'

const LOAD_TIMEOUT_MS = 90_000

interface LoadTracker {
  startTime: number
  timeoutId: ReturnType<typeof setTimeout> | null
  completed: boolean
}

let tracker: LoadTracker | null = null

function handleBeforeUnload(): void {
  if (tracker && !tracker.completed) {
    const duration = performance.now() - tracker.startTime
    trackLoadEvent('incomplete', duration)
  }
}

function trackLoadEvent(
  status: 'success' | 'timeout' | 'incomplete',
  durationMs: number
): void {
  mixpanel.track('Kestrel Load Time', {
    status,
    duration_ms: Math.round(durationMs),
    component: 'kestrel_pixel_streaming',
  })
}

export function cleanupLoadTracking(): void {
  if (tracker?.timeoutId) {
    clearTimeout(tracker.timeoutId)
  }
  window.removeEventListener('beforeunload', handleBeforeUnload)
  tracker = null
}

export function startLoadTracking(): void {
  // Cleanup any existing tracker
  cleanupLoadTracking()

  tracker = {
    startTime: performance.now(),
    timeoutId: null,
    completed: false,
  }

  // Set timeout for failed loads
  tracker.timeoutId = setTimeout(() => {
    if (tracker && !tracker.completed) {
      trackLoadEvent('timeout', LOAD_TIMEOUT_MS)
      tracker.completed = true
    }
  }, LOAD_TIMEOUT_MS)

  // Track incomplete loads on page unload
  window.addEventListener('beforeunload', handleBeforeUnload)
}

export function markLoadComplete(): void {
  if (!tracker || tracker.completed) return

  const duration = performance.now() - tracker.startTime
  trackLoadEvent('success', duration)
  tracker.completed = true
  cleanupLoadTracking()
}
